import styled from 'styled-components/native';
import { Typography as TypographyUI } from '~/components/@hello-ui';

export const Typography = styled(TypographyUI)`
  marginvertical: 8px;
`;
